import { useEffect, useRef } from 'react';
import { useCurrentModule } from '../../ModuleProvider';
const SUBMIT_BUTTON_SELECTOR = '[data-hook="submit-button"]';
export const usePaymentButtonExposed = didInitSuccess => {
  const module = useCurrentModule();
  const hasFiredRef = useRef(false);
  useEffect(() => {
    if (!didInitSuccess || hasFiredRef.current) {
      return;
    }
    const handleButtonVisible = () => {
      if (hasFiredRef.current) {
        return;
      }
      hasFiredRef.current = true;
      module.internals.bi.onPaymentButtonExposed == null || module.internals.bi.onPaymentButtonExposed({});
    };
    const observeButton = button => {
      const intersectionObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          handleButtonVisible();
          intersectionObserver.disconnect();
        }
      }, {
        threshold: 0.5
      });
      intersectionObserver.observe(button);
      return intersectionObserver;
    };
    const button = document.querySelector(SUBMIT_BUTTON_SELECTOR);
    if (button) {
      const observer = observeButton(button);
      return () => observer.disconnect();
    }
    let intersectionObserver;
    const mutationObserver = new MutationObserver(() => {
      const btn = document.querySelector(SUBMIT_BUTTON_SELECTOR);
      if (btn) {
        mutationObserver.disconnect();
        intersectionObserver = observeButton(btn);
      }
    });
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
    return () => {
      var _intersectionObserver;
      mutationObserver.disconnect();
      (_intersectionObserver = intersectionObserver) == null || _intersectionObserver.disconnect();
    };
  }, [didInitSuccess, module.internals.bi]);
};
//# sourceMappingURL=usePaymentButtonExposed.js.map